import useCheckEcocashStatus from "api/PaymentsResource/useCheckEcocashStatus";
import { PaymentStatusCard } from "components";
import useSearchParams from "hooks/useSearchParams";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import useAuthStore from "store/authStore";
import useSupportQueryStore from "store/supportQueryStore";

const PaymentResponse = () => {
	const { userProfile } = useAuthStore();
	const { setQuery } = useSupportQueryStore();
	const { getParam } = useSearchParams();
	const history = useHistory();

	useEffect(() => {
		setQuery(
			`Hi, I am having issues with ecocash payment. Money was deducted from my wallet but the order was not processed successfully. Please help me resolve this issue: Reference: ${getParam(
				"reference"
			)}, Order ID: ${getParam("order_id")}, Phone: ${getParam("phone")}`
		);
	}, [getParam, setQuery]);

	const statusParamIsSuccess = getParam("status") === "Successful";
	const statusParamIsFailed = getParam("status") === "Failed";
	const shouldFetch = !statusParamIsSuccess && !statusParamIsFailed;

	const { isLoading, isTimedOut, elapsedTime, resetTimeout } = useCheckEcocashStatus(
		{
			order_id: getParam("order_id"),
		},
		shouldFetch
	);

	// Handle retry - reset timeout and continue polling
	const handleRetry = useCallback(() => {
		resetTimeout();
	}, [resetTimeout]);

	// Handle cancel - go back to checkout
	const handleCancel = useCallback(() => {
		history.push("/checkout");
	}, [history]);

	// Determine current status
	const getStatus = () => {
		if (statusParamIsSuccess) return "success";
		if (statusParamIsFailed) return "failure";
		if (isTimedOut) return "timeout";
		if (shouldFetch || isLoading) return "loading";
		return "failure";
	};

	const status = getStatus();

	// Build support URL with user info
	const supportUrl = `/support?name=${userProfile?.first_name} ${userProfile?.last_name}&email=${userProfile?.email}`;

	// Get title based on status
	const getTitle = () => {
		switch (status) {
			case "success":
				return "Payment Successful!";
			case "failure":
				return "Payment Not Completed";
			case "timeout":
				return "Confirmation Timeout";
			default:
				return "Confirming Payment";
		}
	};

	return (
		<Container>
			<PaddingX>
				<div className="mt-10 mb-10 flex flex-col justify-center items-center min-h-[60vh]">
					<PaymentStatusCard
						status={status}
						title={getTitle()}
						paymentMethod="EcoCash"
						primaryAction={
							status === "success"
								? { label: "Go to My Library", to: "/my-library" }
								: status === "failure"
								? { label: "Try Again", to: "/checkout" }
								: null
						}
						secondaryAction={
							status === "success"
								? { label: "Browse More Books", to: "/books" }
								: null
						}
						supportUrl={status === "failure" || status === "timeout" ? supportUrl : null}
						reference={getParam("reference") || getParam("order_id")}
						paymentType="Purchase"
						elapsedTime={elapsedTime}
						onCancel={status === "loading" ? handleCancel : null}
						onRetry={status === "timeout" ? handleRetry : null}
					/>
				</div>
			</PaddingX>
		</Container>
	);
};

export default PaymentResponse;
